!--<template>
  <div class="outer-wrapper">
    <div class="container">
      <div class="text-center">
        <h2 class="header-1"><b>How to Delete Your Doodhvale Account</b></h2>
        <!--img src="img/mobikwik_banner.png" /-->
        <div class="dear-cust-div1" style="">
          <h4 style="margin: 10px 0; text-align: justify">
            If you wish to delete your Doodhvale account, please follow the
            steps below carefully. Please note that account deletion is
            permanent, and all associated data will be removed.
          </h4>
        </div>
        <h4>Steps to Delete Your Account:</h4>
        <div class="dear-cust-div1" style="text-align: justify">
          <ul>
            <li>
              Open the Doodhvale Farms App: Begin by launching the Doodhvale app
              on your mobile device.
            </li>
            <li>
              Navigate to the Menu: Tap on the menu icon located in the
              upper-left corner of your screen.
            </li>
            <li>
              Edit Profile Settings: Select the pencil icon at the top of the
              menu to access your profile settings.
            </li>
            <li>
              Open the Options Menu: In the profile settings screen, tap on the
              three-dot menu (overflow menu) in the top-right corner.
            </li>
            <li>
              Choose “Delete Account”: From the options, select "Delete Account"
              to begin the deletion process.
            </li>
            <li>
              Confirm Deletion: Follow any remaining prompts to confirm. Once
              confirmed, your account will be permanently deleted.
            </li>
          </ul>
        </div>
        <div
          style="
            border-color: rgb(233, 236, 239);
            padding: 10px;
            margin-top: 1rem;
            margin-bottom: 1rem;
            border-width: 0px 0px 0px 0.25rem;
            border-style: solid;
            border-image: initial;
            border-radius: 0.25rem;
            text-align: justify;
            border-left-color: #f0ad4e;
          "
        >
          Important: Once deleted, your account and all related data cannot be
          restored.
        </div>
      </div>
      <p>
        If you encounter any issues or have further questions, please feel free
        to contact our support team at
        <a href="mailto:care@doodhvale.com">care@doodhvale.com.</a>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  methods: {},
};
</script>
<style>
.membership p,
.bottomParaDiv p,
h4 {
  text-align: justify;
}
.dear-cust-div1 li {
  list-style-type: number;
}
.header-1 {
  padding-top: 10px;
}
</style>